import type { GovernFunction } from "owa-bundling-light";
import { setConfig } from "owa-bundling-light";
import markImportAsLoaded from "./mutators/markImportAsLoaded";
import isImportLoaded from "./selectors/isImportLoaded";
import type { LogUsageFunction } from "owa-analytics-types";
import { errorThatWillCauseAlert, trace } from "owa-trace";
import { type GlobalFeatureName, isGlobalFeatureEnabled } from "owa-feature-flags";
import { logGreyError } from "owa-analytics";

export function setBundlingConfig(logUsage: LogUsageFunction, govern: GovernFunction, getWithinGovernor: () => boolean): void {
    setConfig({
        markImportAsLoaded,
        isImportLoaded,
        logUsage,
        logError: errorThatWillCauseAlert,
        logGreyError,
        govern,
        getWithinGovernor,
        trace: (message: string) => trace.info(message, "bundling"),
        // We can not import featureFlags in LazyImport because of dependency issue. Passing it as parameter.
        isFeatureEnabled: val => isGlobalFeatureEnabled(val as GlobalFeatureName, true),
    });
}
